@if (loaded && info) {
  <app-search-sidenav #searchSidenav>
    @if (info.categoryName) {
      <div class="col-12 text-center scrollbar-visible p-0">
        <cdk-virtual-scroll-viewport class="h-100"
          itemSize="1000">
          <div class="padding-catalog">
            <div class="page-header"><span>{{info.categoryName | translate | titlecase}}</span></div>
            <div class="filter-bar">
              <button (click)="searchSidenav.openMenu()" class="btn button-filter">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="9" viewBox="0 0 14 9">
                  <g clip-path="url(#clip0_103_1822)">
                    <path d="M0 7H4" stroke="black" stroke-miterlimit="10"/>
                    <path d="M6 7H14" stroke="black" stroke-miterlimit="10"/>
                    <path d="M4 9V5" stroke="black" stroke-miterlimit="10"/>
                    <path d="M14 2H10" stroke="black" stroke-miterlimit="10"/>
                    <path d="M8 2H0" stroke="black" stroke-miterlimit="10"/>
                    <path d="M10 0V4" stroke="black" stroke-miterlimit="10"/>
                  </g>
                  <defs>
                    <clipPath id="clip0_103_1822">
                      <rect width="14" height="9" fill="white"/>
                    </clipPath>
                  </defs>
                </svg>
                <span class="header-buttons-label">{{'pages.catalogList.filters' | translate }}</span>
              </button>
            </div>
            <div class="align-items-center-middle">
              @if (isCopyingConfiguration()) {
                <div class="copying-container">
                  <div class="copying-label"> {{ 'SELECT_TO_COPY' | translate }}
                    <span class="copying-label-cancel" (click)="cancelCopyingConfiguration()">{{'ANNULLA' | translate}}</span>
                  </div>
                </div>
              }
              <!--                <div class="flex-end-padding">-->
              <!--                  <button (click)="catalogList()" class="btn product-index" type="button">-->
              <!--                    <img class="pb-2" src="assets/img/sedia_mattone.svg" height="36">-->
            <!--                  </button>-->
            <!--                  <button (click)="productIndex()" class="btn product-index" type="button">-->
            <!--                    {{ 'INDEX' | translate }}-->
          <!--                  </button>-->
        <!--                </div>-->
      </div>
      @if (loaded) {
        <div class="pt-4 px-xl-5 catalog">
          <div class="row text-center">
            @for (model of productModels; track model) {
              <div (click)="modelDetail(model)"
                class="col-lg-3 col-md-4 col-sm-6 model">
                <img
                  [hidden]="!model.imageLoaded"
                  (load)="imageLoaded(model)"
                  [alt]="model?.modelName"
                  [src]="(model.images.list[model.images.indexPos] || '') | repairImageUrl"
                  (error)="convertProductImage(model, true)"
                  class="model-image"/>
                @if (!model.imageLoaded) {
                  <app-loading [isBlock]="true" width="75%" height="auto" class="model-image"></app-loading>
                }
                <p class="model-name my-2">{{model?.modelName | titlecase}}</p>
              </div>
            }
          </div>
        </div>
      }
      @if (!loaded) {
        <app-visionnaire-loader class="ipe:w-full" />
      }
    </div>
  </cdk-virtual-scroll-viewport>
</div>
}
</app-search-sidenav>
}
@if (!loaded) {
  <app-visionnaire-loader class="ipe:w-full" />
}
